import { axiosFunc } from "../commonFunction";
import Config from "../../config/config";


const errMsg = (msg) => {
    return { status: false, message: msg.toString() };
};

export const getListingsAxios = async (data) => {
    try {
        let respData = await axiosFunc({
            method: "GET",
            url: `${Config.v1Url}admin/getListings`,
            params: data
        });
        return respData.data;
    } catch (err) {
        console.log("🚀 ~ subcatHideShowAxios ~ err:", err);
        errMsg(err);
    }
};


export const getCmsAxiosRecord = async (data) => {
    try {
        let respData = await axiosFunc({
            method: "GET",
            url: `${Config.v1Url}user/getcms`,
            params: data,
        });
        return respData.data;
    } catch (err) {
        console.log("🚀 ~ getCmsAxios ~ err:", err);
        errMsg(err);
    }
};

export const getFormsAxios = async (data) => {
    try {
      let respData = await axiosFunc({
        method: "GET",
        url: `${Config.v1Url}admin/getForms`,
        params: data
      });
      return respData.data;
    } catch (err) {
      console.log("🚀 ~ getFormsShowAxios ~ err:", err);
      errMsg(err);
    }
  };

  export const formStatusUpdatefront = async (data) => {
    try {
      let respData = await axiosFunc({
        method: "GET",
        url: `${Config.v1Url}admin/formStatusUpdate`,
        params: data
      });
      return respData.data;
    } catch (err) {
      console.log("🚀 ~ wwww ~ err:", err);
      errMsg(err);
    }
  };